const articlesLimitPerPage = 20

export {articlesLimitPerPage}